import styled from 'styled-components/macro';

export const StyledUserInstitutionSelectWrapper = styled.div`
  width: 300px;
  .ant-select-selector .ant-select-selection-item {
    width: 300px;
  }
`;
